export default __webpack_public_path__ + "d4cef8739cbeece9ba423f23be15af94.png";